import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function ProtectedRoute({ children, redirectTo = "/" }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Show a blank screen or loading spinner while Firebase checks the user token
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 font-bold">
        Verifying Session...
      </div>
    );
  }

  // If the user is NOT logged in, bounce them to the specified route (defaults to "/")
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // If the user IS logged in, render the requested page
  return children;
}